var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import * as Icons from '../../atoms/icons';
import { theme } from '../../theme';
import { IconLoading } from '../../atoms/icons/24x24/Loading';
import BaseButton from './BaseButton';
import { focusStyles, errorStyles } from './BaseButton';
var getButtonPadding = function (props) {
    if (props.size === 'small')
        return '12px 24px';
    if (props.size === 'extraSmall')
        return '8px 16px';
    if (props.icon)
        return '20px';
    return '16px 24px';
};
var getButtonWidth = function (props) {
    if (props.stretch)
        return '100%';
    return 'auto';
};
var getButtonHeight = function (props) {
    if (props.large)
        return '68px';
    return 'auto';
};
var GeneralBase = styled(BaseButton).attrs(function () { return ({
    className: 'button button__general',
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    ", "\n    padding: ", ";\n    width: ", ";\n    height: ", ";\n    background: ", ";\n    color: white;\n    border: none;\n    justify-content: ", ";\n\n    &:hover {\n      background: ", ";\n    }\n\n    &:active {\n      background: ", ";\n    }\n\n    &:focus-visible {\n      &:before {\n        ", "\n      }\n    }\n    &:before {\n      ", "\n    }\n\n    .icon {\n      height: 16px;\n      margin: ", ";\n      margin: ", ";\n    }\n    .loading {\n      position: absolute;\n    }\n    .label {\n      ", ";\n    }\n  }\n  ", "\n"], ["\n  && {\n    ", "\n    padding: ", ";\n    width: ", ";\n    height: ", ";\n    background: ", ";\n    color: white;\n    border: none;\n    justify-content: ", ";\n\n    &:hover {\n      background: ", ";\n    }\n\n    &:active {\n      background: ", ";\n    }\n\n    &:focus-visible {\n      &:before {\n        ", "\n      }\n    }\n    &:before {\n      ", "\n    }\n\n    .icon {\n      height: 16px;\n      margin: ", ";\n      margin: ", ";\n    }\n    .loading {\n      position: absolute;\n    }\n    .label {\n      ", ";\n    }\n  }\n  ", "\n"])), theme.special.button.font, function (props) { return getButtonPadding(props); }, function (props) { return getButtonWidth(props); }, function (props) { return getButtonHeight(props); }, theme.primaryColours.aubergine.main, function (props) { return props.spaceBetween && 'space-between'; }, theme.primaryColours.aubergine.darkAubergine, theme.primaryColours.aubergine.lightAubergine, focusStyles(), function (props) { return props.error && errorStyles(); }, function (props) { return props.icon && '-8px 12px 0 0'; }, function (props) { return props.iconRight && 0; }, function (props) { return props.loading && 'opacity: 0'; }, function (_a) {
    var disabled = _a.disabled;
    return disabled &&
        "background: ".concat(theme.tints.darkAubergine, "!important;\n        cursor: normal;\n      ");
});
export var ButtonGeneral = function (props) {
    var Icon = Icons[props.iconRight || props.icon];
    return (_jsxs(GeneralBase, __assign({}, props, { children: [props.icon && Icon && _jsx(Icon, { fill: "white" }), props.loading && (_jsx("div", __assign({ className: "loading" }, { children: _jsx(IconLoading, { fill: "white" }) }))), _jsx("div", __assign({ className: "label" }, { children: props.label })), props.iconRight && Icon && _jsx(Icon, { fill: "white" })] })));
};
var templateObject_1;
